export default {
  addressLabel: "Address",
  tagAlt: "Tag",
  chainAlt: "Chain",
  debugWidth: "I am width",
};
